import React, { useState } from 'react';
import 'react-pro-sidebar/dist/css/styles.css';
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, NavLink, useLocation } from 'react-router-dom';
import YourLogo from '../../Assets/Images/Pro_Logo.png';
import '../../Assets/Style/style.css';
import './sidebar.css';
import { RxHamburgerMenu } from 'react-icons/rx';
import { AiOutlineStock, AiOutlineBulb, AiOutlineSearch } from 'react-icons/ai';
import { TbFileInvoice, TbRepeat, TbTruckDelivery, TbUpload } from 'react-icons/tb';
import { useSelector } from 'react-redux';
import { getCompany } from '../../../Redux/selecters';
// import { useClientFeatures } from '../../utils/clientFeatures'; // needed when the Lease Revenue Postings menu item is uncommented
import { MdCancel, MdOutlineUndo, MdOutlineAutorenew } from 'react-icons/md';
import { FcApproval } from 'react-icons/fc';
import { FaMailBulk, FaFileInvoice, FaFileInvoiceDollar } from 'react-icons/fa';
import { BiWindowClose } from 'react-icons/bi';
import { IoReceiptOutline } from 'react-icons/io5';
import { CiCircleChevLeft, CiCircleChevRight } from 'react-icons/ci';
import { MdOutlineInventory } from 'react-icons/md';
import { BsFillPostcardFill } from 'react-icons/bs';

const PMSideBar = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const companies = useSelector(getCompany);
  // const { canEditRevenuePostings } = useClientFeatures(); // needed when the Lease Revenue Postings menu item is uncommented

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };
  const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
  const accessibleForms = storedPermissions.filter((form) => form.canView);
  const [permissions, setPermission] = useState(accessibleForms);
  const [searchTerm, setSearchTerm] = useState('');
  const isSearching = searchTerm.trim().length > 0;

  const isVisible = (formNames) => {
    const names = Array.isArray(formNames) ? formNames : [formNames];
    const hasPermission = permissions?.some((p) => names.includes(p.formName) && p.canView);
    if (!hasPermission) return false;
    if (!isSearching) return true;
    const term = searchTerm.trim().toLowerCase();
    return names.some((name) => name.toLowerCase().includes(term));
  };

  const leaseFormNames = ['Lease Proposal', 'Lease Revenue', 'Proposal Approval', 'Lease Approval', 'Lease Agreement ', 'Lease Renew List', 'Termination', 'Leased Installments Change'];
  const hasLeaseMatch = leaseFormNames.some((name) => isVisible(name));

  const invoiceFormNames = ['Single Invoice', 'Installment Invoice', 'Invoice Approval', 'Lease General Invoice'];
  const hasInvoiceMatch = invoiceFormNames.some((name) => isVisible(name));

  const receiptFormNames = ['Lease Receipt', 'Lease Bulk Receipt', 'Lease Reverse Receipt'];
  const hasReceiptMatch = receiptFormNames.some((name) => isVisible(name));

  const postingFormNames = ['Lease Revenue'];
  const hasPostingMatch = postingFormNames.some((name) => isVisible(name));

  const reportFormNames = [
    'Available Unit Report',
    'Lease Statement Report',
    'Tax Statement Report',
    'Tenant Invoice Report',
    'Occupancy Report',
    'Lease Outstanding Report',
    'Month Wise Revenue Report',
    'Unit Master List Report',
    'Revenue Against Invoices Report',
    'Lease Aging Analysis Report',
    'Lease Move In Move Out Report',
    'Lease Receipt Report',
    'PDC List Report',
    'Cheque List Report',
    'Accrued Rent Report',
  ];
  const hasReportMatch = reportFormNames.some((name) => isVisible(name));

  return (
    <div>
      <ProSidebar collapsed={collapsed}>
        {collapsed ? (
          // <a href="/" className="navbar-brand start">
          //   <img src={companies?.selectedCompany?.logo || YourLogo} alt="Logo" style={{ height: '40px', paddingTop: '8px', paddingBottom: '8px' }} />
          // </a>
          ''
        ) : (
          <a href="/" className="navbar-brand start">
            <img src={companies?.selectedCompany?.logo || YourLogo} alt="Logo" style={{ height: '75px' }} />
          </a>
        )}
        {!collapsed && (
          <div className="sidebar-search">
            <AiOutlineSearch size={18} />
            <input
              type="text"
              placeholder="Search menu..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {isSearching && (
              <span className="sidebar-search-clear" onClick={() => setSearchTerm('')}>
                ×
              </span>
            )}
          </div>
        )}
        <Menu className="mt-2">
          {/* Dashboard */}
          {isVisible('Dashboard') && (
            <MenuItem icon={<AiOutlineStock size={22} />} active={location.pathname === '/'}>
              <NavLink to="/">Dashboard</NavLink>
            </MenuItem>
          )}

          {/* Lease Section */}
          {(!isSearching || hasLeaseMatch) && (
            <SubMenu icon={<BsFillPostcardFill size={22} />} title="Lease" open={isSearching ? hasLeaseMatch : undefined}>
              {isVisible(['Lease Proposal', 'Lease Revenue']) && (
                <MenuItem icon={<TbUpload size={18} />}>
                  <NavLink to="/Property/Management/Lease/Proposal/Listing">Lease Proposal</NavLink>
                </MenuItem>
              )}

              {isVisible(['Proposal Approval', 'Lease Approval']) && (
                <MenuItem icon={<FcApproval size={18} />}>
                  <NavLink to="/Property/Management/Proposal/Approval">Proposal Approval</NavLink>
                </MenuItem>
              )}

              {isVisible('Lease Agreement ') && (
                <MenuItem icon={<AiOutlineBulb size={18} />}>
                  <NavLink to="/Property/Management/LeaseAgreement">Lease Agreement</NavLink>
                </MenuItem>
              )}

              {isVisible('Lease Renew List') && (
                <MenuItem icon={<MdOutlineAutorenew size={18} />}>
                  <NavLink to="/Property/Management/Lease/Renew/Listing">Lease Renewal</NavLink>
                </MenuItem>
              )}

              {isVisible('Lease Approval') && (
                <MenuItem icon={<FcApproval size={18} />}>
                  <NavLink to="/Property/Management/Approval">Agreement Approval</NavLink>
                </MenuItem>
              )}

              {isVisible('Leased Installments Change') && (
                <MenuItem icon={<MdOutlineAutorenew size={18} />}>
                  <NavLink to="/Property/Management/Lease/Installments/Change">Leased Installments Change</NavLink>
                </MenuItem>
              )}

              {isVisible('Termination') && (
                <MenuItem icon={<MdCancel size={18} />}>
                  <NavLink to="/Property/Management/Lease/Termination/Listing">Lease Termination</NavLink>
                </MenuItem>
              )}

            </SubMenu>
          )}

          {/* Invoices */}
          {(!isSearching || hasInvoiceMatch) && (
            <SubMenu icon={<FaFileInvoiceDollar size={22} />} title="Invoices" open={isSearching ? hasInvoiceMatch : undefined}>
              {isVisible('Single Invoice') && (
                <MenuItem icon={<TbFileInvoice size={18} />}>
                  <NavLink to="/Property/Management/Single/Invoice/Listing">Single Invoice</NavLink>
                </MenuItem>
              )}

              {isVisible('Installment Invoice') && (
                <MenuItem icon={<FaFileInvoiceDollar size={18} />}>
                  <NavLink to="/Property/Management/Installment/Invoice/Listing">Installment Invoice</NavLink>
                </MenuItem>
              )}

              {isVisible('Invoice Approval') && (
                <MenuItem icon={<FaFileInvoice size={18} />}>
                  <NavLink to="/Property/Management/Invoice/Approval">General Invoice Approval</NavLink>
                </MenuItem>
              )}

              {isVisible('Lease General Invoice') && (
                <MenuItem icon={<BiWindowClose size={18} />}>
                  <NavLink to="/Property/Management/Lease/GeneralInvoice/listing">Lease General Invoice</NavLink>
                </MenuItem>
              )}
            </SubMenu>
          )}

          {/* Receipts */}
          {(!isSearching || hasReceiptMatch) && (
            <SubMenu icon={<IoReceiptOutline size={22} />} title="Receipts" open={isSearching ? hasReceiptMatch : undefined}>
              {isVisible('Lease Receipt') && (
                <MenuItem icon={<FaFileInvoice size={18} />}>
                  <NavLink to="/Property/Management/Lease/Receipt/Listing">Lease Receipt</NavLink>
                </MenuItem>
              )}

              {isVisible('Lease Bulk Receipt') && (
                <MenuItem icon={<FaMailBulk size={18} />}>
                  <NavLink to="/Property/Management/Lease/Bulk/Receipt/Listing">Lease Bulk Receipt</NavLink>
                </MenuItem>
              )}

              {isVisible('Lease Reverse Receipt') && (
                <MenuItem icon={<MdOutlineUndo size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reverse/Receipt">Lease Reverse Receipt</NavLink>
                </MenuItem>
              )}
            </SubMenu>
          )}

          {/* Posting & Revenue */}
          {(!isSearching || hasPostingMatch) && (
            <SubMenu icon={<TbRepeat size={22} />} title="Posting & Revenue" open={isSearching ? hasPostingMatch : undefined}>
              {isVisible('Lease Revenue') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Revenue/Posting">Lease Revenue Posting</NavLink>
                </MenuItem>
              )}
              {/* Hidden for now - uncomment to show the Jaberi revenue postings list in the menu
              {canEditRevenuePostings && isVisible('Lease Revenue') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Revenue/Postings">Lease Revenue Postings</NavLink>
                </MenuItem>
              )}
              */}

              {/* {permissions?.some((p) => p.formName === 'ManagePayment' && p.canView) && ( */}
              {/* <MenuItem icon={<MdCancel size={18} />}>
              <NavLink to="/Property/Management/Lease/Payment/Management">Manage Payment</NavLink>
            </MenuItem> */}
              {/* )} */}

              {/* <MenuItem icon={<MdOutlineUndo size={18} />}>
              <NavLink to="/Property/Management/Lease/Posting">Lease Posting</NavLink>
            </MenuItem> */}
            </SubMenu>
          )}

          {/* Inventory */}
          {isVisible('Inventory Update') && (
            <MenuItem icon={<MdOutlineInventory size={22} />}>
              <NavLink to="/Property/Management/Lease/Inventory/Update">Inventory Update</NavLink>
            </MenuItem>
          )}


          {/* {permissions?.some(p => p.formName === 'Inventory Update' && p.canView) && (
            <MenuItem icon={<MdOutlineInventory size={22} />}>
              <NavLink to="/Property/Management/Customer/Listing">
                Customer Management
              </NavLink>
            </MenuItem>
          )} */}
          {(!isSearching || hasReportMatch) && (
            <SubMenu icon={<IoReceiptOutline size={22} />} title="Reports" open={isSearching ? hasReportMatch : undefined}>
              {isVisible('Available Unit Report') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reports/Occupancy">Available Units Report</NavLink>
                </MenuItem>
              )}
              {isVisible('Lease Statement Report') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reports/leaseStatment">Lease Statement Report</NavLink>
                </MenuItem>
              )}
              {isVisible('Tax Statement Report') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reports/TaxStatement">Tax Statement Report</NavLink>
                </MenuItem>
              )}
              {isVisible('Tenant Invoice Report') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reports/TenantInvoice">Tenant Invoice Report</NavLink>
                </MenuItem>
              )}
              {isVisible('Occupancy Report') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reports/TenantOccupancy">Occupancy Report</NavLink>
                </MenuItem>
              )}
              {isVisible('Lease Outstanding Report') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reports/LeaseOutstanding">Lease Outstanding Report</NavLink>
                </MenuItem>
              )}
              {isVisible('Month Wise Revenue Report') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reports/MonthWiseRevenue">Month Wise Revenue</NavLink>
                </MenuItem>
              )}
              {isVisible('Unit Master List Report') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reports/UnitMasterList">Unit Master List Report</NavLink>
                </MenuItem>
              )}
              {isVisible('Revenue Against Invoices Report') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reports/RevenueAgainstInvoices">Revenue Against Invoices Report</NavLink>
                </MenuItem>
              )}
              {isVisible('Lease Aging Analysis Report') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reports/AgingAnalysis">Lease Aging Analysis Report</NavLink>
                </MenuItem>
              )}
              {isVisible('Lease Move In Move Out Report') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reports/MoveInMoveOut">Move In / Move Out Report</NavLink>
                </MenuItem>
              )}
              {isVisible('Lease Receipt Report') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reports/LeaseReceipts">Lease Receipt Report</NavLink>
                </MenuItem>
              )}
              {isVisible('PDC List Report') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reports/PDCList">PDC Report</NavLink>
                </MenuItem>
              )}
              {isVisible('Cheque List Report') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reports/ChequeList">Cheque Report</NavLink>
                </MenuItem>
              )}
              {isVisible('Accrued Rent Report') && (
                <MenuItem icon={<BsFillPostcardFill size={18} />}>
                  <NavLink to="/Property/Management/Lease/Reports/AccruedRent">Accrued Rent Report</NavLink>
                </MenuItem>
              )}
            </SubMenu>
          )}
        </Menu>
        <div onClick={handleToggle} className="sidebar-toggle-btn" style={{ left: collapsed ? '100px' : '300px' }}>
          <RxHamburgerMenu size={25} />
        </div>
      </ProSidebar>
    </div>
  );
};

export default PMSideBar;
